import { MODULE } from "./scheduleStateFilter.actionTypes";

export const getScheduleState = (state) => state.getIn([MODULE, "scheduleState"]);
